/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
import { Box } from '@mui/system';
import { InsertLink, InsertDriveFile } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Popover from '@mui/material/Popover';
import { FC, MouseEvent, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { formatBytes } from '../../../helper/converters';
import { IFiles } from '../../../config/interfaces';

const renderPDF: FC<IFiles> = (fileAux) => {
  const file = fileAux.base64 ? _base64ToArrayBuffer(fileAux.base64) : fileAux.file;
  return (
    <div>
      {file && (
        <Document
          file={file}
        >
          <Page pageNumber={1} />
        </Document>
      )}
    </div>
  )
}

const _base64ToArrayBuffer = (base64: string) => {
  const binaryString = window.atob(base64.replace(/\+/g, ' '));
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

const ListFiles = (props: any) => props.files.map((file: IFiles, index: number) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box key={index}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          border: 1,
          borderStyle: 'solid',
          borderColor: '#E5E5E5',
          borderRadius: '9px',
          opacity: 1,
          padding: '1em',
          margin: '0.7em 0 0 0',
          backgroundColor: props.styles ? props.styles.backgroundColor : 'transparent',
        }}
        key={index}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {
            file.link_url
              ? <InsertLink fontSize="large" />
              : <InsertDriveFile fontSize="large" />
          }
          <Box>
            <Typography
              component="p"
              variant="h5"
            >
              {file.name ? file.name : file.file_name}
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              {file.size ? formatBytes(file.size) : (file.link_url || '')}
            </Typography>
          </Box>
        </Box>
        {props.removeFile && (
          <IconButton onClick={() => props.removeFile(file)}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      {props.preview && (
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: 'none',
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
        >
          {renderPDF(file)}
        </Popover>
      )}
    </Box>
  )
})

export default ListFiles;
